import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export default function FloatNumberFormatText(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            decimalSeparator=","
            thousandSeparator="."
            isNumericString={true}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={'text'}
        />
    );
};

FloatNumberFormatText.propTypes = {
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
};